﻿/// <reference path="../@types/alertify/index.d.ts" />
import { global } from "../Common/saop-common";
import { SaopUploadFiles } from "../Components/saop-upload-files";
import { SaopServicesCore } from "../Core/saop-services-core";

export class SaopSplDocumentView {
    public saopUploadFiles:SaopUploadFiles;
    private _saopServicesCore: SaopServicesCore;

    constructor(viewId: string, libName: string = "") {
        this.saopUploadFiles = new SaopUploadFiles(viewId,libName+".saopUploadFiles");
        this.saopUploadFiles.afterSubmitSuccess = this.afterSubmitSuccess;
        this._saopServicesCore = new SaopServicesCore();
    }

    initView(): void {
        global.ConsoleLogDegug("SaopSplDocumentView.initView");
        // form nima sidebar right, zato se dodan class, da btn ni viden tudi v mobile verziji
        $("#btnShowSidebarr").addClass("d-none-mobile");
        this.bindControls();

        let _this = this;
        _this.setHeight();
        window.onresize = function () {
            _this.setHeight();
        };
    }

    bindControls() {
        global.ConsoleLogDegug("SaopSplDocumentView.bindGridEvents");
        let _this = this;
        $(".btnUploadSPLDocuments").off("click");
        $(".btnUploadSPLDocuments").on('click', function (row) {
            global.ConsoleLogDegug("SaopSplDocumentView.btnUploadSPLDocuments.click");
            let title = row.target.getAttribute("data-formtitle");
            _this.saopUploadFiles.viewTitle = title;
            _this.saopUploadFiles.initView({controller:"SPLDocument",action:"GetUploadDocuments"});
        });
    }

     refreshDocumentTreeData(): void {
        global.ConsoleLogDegug("SaopSplDocumentView.refreshDocumentTreeData");

        let _this = this;
        let data = null;

        this._saopServicesCore.afterDone = function (response) {
            $("#documentTree").html(response);
            _this.bindControls();
        };
        this._saopServicesCore.ExecuteAction({
            action: "SPLDocument/GetDocumentTree"
            , data: data
            , type: "GET"
            , spinnerDivId: "#documentTreeDataLoading"
        });
 }

    public afterSubmitSuccess = (result:any): void => {
        global.ConsoleLogDegug("afterExecuteSuccess");
            if(result.success) {
                this.refreshDocumentTreeData();
        }
        
    }  

    setHeight() {
        var header = $("#site-header").height();
        var footer = $("#site-footer").height();
        $("#documentTree").height(window.innerHeight - header - footer - 1);
    }
    //
}


